<!-- <app-nav-bar [variant]="navbarVariant"></app-nav-bar> -->
<app-nav-bar></app-nav-bar>

<main class="container">
  <router-outlet></router-outlet> <!-- Aquí se renderizan las pages -->
</main>

<footer>
  <app-footer></app-footer>
</footer>

